import { Col, Container, Row } from "reactstrap";
import JobGridHeader from "./JobGridHeader";
import JobVacancy from "./JobVacancy";
import Section from "./Section";
import Selected from "./Selected";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const JobGrid = () => {
  document.title = "Avanza | Empleos";
  
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const categoryParam = searchParams.get('category');
  
  const [filters, setFilters] = useState({
    companyName: "",
    department: null,
    city: null,
    categoryId: null
  });

  const [categoryFilter, setCategoryFilter] = useState(null);

  useEffect(() => {
    const newCategory = categoryParam ? parseInt(categoryParam) : null;
    // Solo actualizar si el valor realmente cambió
    setCategoryFilter(prev => prev === newCategory ? prev : newCategory);
  }, [categoryParam]);

  return (
    <React.Fragment>
      <Section />
      <section className="section">
        <Container>
          <JobGridHeader setFilters={setFilters} />
          <Selected />
          <Row>
            <Col lg={12}>
              <JobVacancy filters={filters} categoryFilter={categoryFilter} />
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default JobGrid;
